import api.ApiService
import components.routing.ProtectedRouting
import components.routing.UnprotectedRouting
import components.wrapper.Wrapper
import api.dataclasses.Session
import mui.material.CssBaseline
import mui.system.ThemeProvider
import react.FC
import react.Props
import react.router.dom.BrowserRouter
import react.router.dom.HashRouter
import react.useEffectOnce
import react.useState
import theme.DarkTheme
import theme.LightTheme

val Application= FC<Props>("Application") {props ->
    val (activeSessionState, setActiveSessionState) = useState<Session?>(null)
    val (darkModeState, setDarkModeState) = useState(false)

    // @ICS-01
    useEffectOnce {
        if (activeSessionState == null) ApiService.checkLocalSession()?.let {
            setActiveSessionState(it)
        }
    }


    ThemeProvider {
        theme = if (darkModeState) DarkTheme else LightTheme

        CssBaseline()
        
        BrowserRouter {
            if (activeSessionState == null) {
                UnprotectedRouting {
                    sessionSetter = setActiveSessionState
                    darkMode = darkModeState
                }
            } else {
                Wrapper {
                    session = activeSessionState
                    sessionSetter = setActiveSessionState
                    darkMode = darkModeState

                    // page content
                    ProtectedRouting {
                        session = activeSessionState
                        sessionSetter = setActiveSessionState
                        darkMode = darkModeState
                    }
                }
            }

        }
    }


}